import {trigger, p, lazy, s} from './lang.js';
import {doc} from './documentation.js';

doc(
    "augment",
    {
        delayTime: "",
        transpose: "",
        everyTime: "",
        scriptFunction: "optional",
        hold: "",
    },
    "augmentation to theme");

export const augment = (delayTime, trans, everyTime, fn, hold) => {
    let delayLine = [];
    let counter=0;
    let lastStepNumber = undefined;
    return (... args) => {
        let [stepData, stepNumber, time, effect] = args;
        if (lastStepNumber !== 0 && stepNumber === 0) {
            lastStepNumber = undefined;
        }    
        let delays = [];
        if (stepData) {
            if (lastStepNumber !== stepNumber && lastStepNumber !== undefined) {
                counter++;
            }
            lastStepNumber = stepNumber;
            if (everyTime === undefined || 
                counter % lazy(everyTime, ... args) === 0) {
                let _delayTime = lazy(delayTime, ... args) + 1;

                // store trigger in the delay line to later
                // trigger
                let obj = {
                    stepData, 
                    time: time - effect.currentTime,
                    delay: _delayTime,
                    reference: {},
                };

                // when the original trigger

                delays.push(obj);
                delayLine.push(obj);
            }
        }
        let triggers = [];
        let _delayLine = [];
        for (let pos of delayLine) {
            pos.delay--;
            if (pos.delay <= 0) {    
                let _stepData = effect.getStep(pos.stepData);
                if (lazy(hold, ...args)) {
                    _stepData.duration = Infinity;
                } else {
                    _stepData.duration *= 2;
                }
                if (trans !== undefined) {
                    let _trans = lazy(trans, _stepData, ...args.slice(1));
                    _stepData.transpose += _trans;
                }
                let obj = {
                    stepData: _stepData,
                    time: pos.time + effect.currentTime,
                    stepNumber,
                    reference: pos.reference
                };
                pos.reference.transpose = _stepData.transpose;
                if (fn) {
                    triggers.push( 
                        s(
                            trigger(obj),
                            fn // run the function after this delayed trigger
                        )
                    );  
                } else {
                    triggers.push(trigger(obj));
                }  
            } else {
                _delayLine.push(pos);
            }
        }  
        delayLine = _delayLine;
        if (stepData) {
            stepData.delays = delays;
        }
        triggers.push(trigger({
            stepData,
            time,
            stepNumber,
        }));
        
        return p(...triggers);
    }
};
